var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAffiliateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74609 1.90527V23.9053",
    stroke: "#CFD0E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7461 5.90527H5.24609C4.31784 5.90527 3.4276 6.27402 2.77122 6.9304C2.11484 7.58678 1.74609 8.47702 1.74609 9.40527C1.74609 10.3335 2.11484 11.2238 2.77122 11.8801C3.4276 12.5365 4.31784 12.9053 5.24609 12.9053H10.2461C11.1744 12.9053 12.0646 13.274 12.721 13.9304C13.3773 14.5868 13.7461 15.477 13.7461 16.4053C13.7461 17.3335 13.3773 18.2238 12.721 18.8801C12.0646 19.5365 11.1744 19.9053 10.2461 19.9053H1.74609",
    stroke: "#CFD0E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffiliateIcon);
export default __webpack_public_path__ + "static/media/affiliate_icon.c54c3f2ea64d4700aaf044fd22d9a26f.svg";
export { ForwardRef as ReactComponent };